import { createFileRoute } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/site-import-jobs'
)({
  meta: () => [{ title: MENU.SITE_IMPORT_HISTORY }]
})
